// extracted by mini-css-extract-plugin
export default {"info-wrapper":"announcements_info-wrapper__oz0yN"};